import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Grid,
  Typography,
  Avatar,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    borderRadius: '10px',
    display: 'flex',
    flex: 1,
    '&:hover': {
      backgroundColor: '#F5F5F5',
      cursor: 'pointer'
    }
  },
  snapshot: {
    alignItems: 'flex-start',
    flex: 1,
    flexDirection: 'column',
    padding: '10px 5px',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  },
  avatar: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '5px',
      marginLeft: '8px',
      height: '30px',
      width: '30px'
    },
  },
  snapshotInfo: {
    alignContent: 'center',
    alignItems: 'flex-start',
    flex: 1,
    padding: '0px 20px 0px 10px',
    width: '100%'
  },
  blueBar: {
    alignSelf: 'center',
    backgroundColor: '#5867DD',
    borderRadius: '2px',
    display: 'flex',
    height: '90%',
    marginRight: '5px',
    width: '5px'
  },
  text: {
    color: 'black'
  }
}));

const MessageSnapshot = ({ message }) => {
  const classes = useStyles();
  const {
    img,
    subject,
    timeStamp,
    from,
    read
  } = message;

  return (
    <div className={classes.root}>
      <div
        style={{
          marginRight: read ? '10px' : null,
        }}
        className={!read ? classes.blueBar : ''}
      />
      <Grid
        className={classes.snapshot}
        container
        item
      >
        <Avatar className={classes.avatar} alt="User image" src={img} />
        <Grid className={classes.snapshotInfo}>
          <Grid
            style={{ flex: 1 }}
            container
            item
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <Typography className={classes.text} style={{ fontWeight: 'bold' }} variant="subtitle2">
              {
                from[0].name ? `${from[0].name} ${from[0].lastName}` : from[0].email
              }
            </Typography>
          </Grid>
          <Grid style={{ flex: 1 }} item>
            <Typography
              style={{
                width: '80%',
              }}
              className={classes.text}
              variant="body2"
            >
              {subject}
            </Typography>
          </Grid>
          <Grid style={{ flex: 1 }} container item direction="row" justify="space-between">
            <Typography className={classes.text} variant="caption">
              {from[0].email}
            </Typography>
            <Typography className={classes.text} variant="caption">
              {timeStamp}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

MessageSnapshot.propTypes = {
  message: PropTypes.shape.isRequired,
};

export default MessageSnapshot;
